import { AuthorCard } from 'components/Author/AuthorCard';
import { Box } from 'components/Box';
import { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import {
  CmsBodyHolder,
  CmsBodyHolderWidth,
} from 'modules/cms/components/Body/CmsBodyHolder';
import { CmsReactions } from 'modules/cms/components/Reactions/CmsReactions';
import { CmsTagList } from 'modules/cms/components/TagList';
import { useCmsApiPageHomePageMeta } from 'modules/cms/hooks';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

type Props = {
  content: CmsApiPagePost;
};

export function CmsBodyMainContentPostBelowBlocks({ content }: Props) {
  const { user } = useUserEnvironment();
  const { homePageUrl } = useCmsApiPageHomePageMeta({
    cmsApiPage: content,
  });

  return (
    <>
      {content.tags && content.tags.length > 0 ? (
        <Box mb={32}>
          <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
            <CmsTagList
              homePageUrl={content.subsite.homePage?.url}
              tags={content.tags}
            />
          </CmsBodyHolder>
        </Box>
      ) : null}

      {content.author ? (
        <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
          <AuthorCard
            author={content.author}
            homePageUrl={homePageUrl}
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </CmsBodyHolder>
      ) : null}
      {user?.hasIdealistProfileFeature && content.hasReactions ? (
        <CmsBodyHolder $width={CmsBodyHolderWidth.NARROW_LAYOUT}>
          <CmsReactions contentId={content.id} />
        </CmsBodyHolder>
      ) : null}
    </>
  );
}
